<template>
  <cos-modal
    v-model:visible="visible"
    :title="
      h('div', { class: 'title-box' }, [
        h('div', { class: 'title-div' }, editForm.id ? t('btn.edit') : t('btn.add')),
        h('span', { class: 'title-span' }, t('operate.8z1gsl'))
      ])
    "
    width="600px"
    @ok="handleSubmit"
    :confirmLoading="loading"
  >
    <a-form :model="editForm" ref="formRef" v-if="visible" autocomplete="off">
      <a-form-item
        name="refId"
        :label="t('operate.6rj8gj')"
        :rules="[{ required: true, message: t('common.pleaseSelect') }]"
      >
        <CustomerSelect v-model:value="editForm.refId" appId="cos_ofbu" v-model:label="editForm.customerName" />
      </a-form-item>
      <a-form-item
        name="blacklistReason"
        :label="t('operate.kmrvx1')"
        :rules="[{ required: true, message: t('common.pleaseSelect') }]"
      >
        <CosApiSelect
          :api="getBlackReason"
          show-search
          mode="tags"
          optionFilterProp="label"
          :placeholder="t('common.pleaseSelect')"
          v-model:value="editForm.blacklistReason"
          :fieldNames="{ label: 'name', value: 'id' }"
        ></CosApiSelect>
      </a-form-item>
      <a-form-item name="blacklistRemark" :label="t('operate.d855tr')">
        <CosTextarea
          v-model:value="editForm.blacklistRemark"
          :placeholder="t('common.pleaseInput')"
          :auto-size="{ minRows: 2, maxRows: 5 }"
          :maxlength="500"
        />
      </a-form-item>
    </a-form>
  </cos-modal>
</template>
<script lang="ts">
import { ref, h } from 'vue'
import { blacklist, editData } from '@/api/overseasSales/blackList'
import type { FormInstance } from 'ant-design-vue'
import { DcMessage } from '@dc-platform/dc-components'
import { listByParamCodes } from '@/api/common'
import type { BlackFindByPageBackData } from '@/typings/api/overseasSales'
import CustomerSelect from '@/components/ClueAndCustomerSelect/src/customer.vue'
import { useI18n } from 'vue-i18n'
export default { name: 'editModal' }
</script>
<script setup lang="ts">
const { t } = useI18n()
const visible = ref<boolean>(false)
const loading = ref<boolean>(false)
const formRef = ref<FormInstance>()
const editForm = ref<BlackFindByPageBackData>({})
const emit = defineEmits(['success'])
const toggle = (row?: BlackFindByPageBackData) => {
  visible.value = !visible.value
  if (row && row.id) {
    editForm.value = { ...row }
  } else {
    editForm.value = {}
  }
}
const getBlackReason = async () => {
  try {
    const res = await listByParamCodes({
      appId: 'cos_ofbu',
      paramCodes: ['ofbu_black_reason']
    })
    return res.data.ofbu_black_reason
  } catch (error) {
    console.log('getBlackReason error: ', error)
  }
}
const handleSubmit = () => {
  formRef.value?.validate().then(async () => {
    loading.value = true
    editForm.value.appId = 'cos_ofbu'
    try {
      if (editForm.value.id) {
        await editData(editForm.value)
      } else {
        await blacklist(editForm.value)
      }
      loading.value = false

      emit('success', editForm.value?.id ? 'edit' : 'add')
      DcMessage.success(editForm.value?.id ? t('operate.mmet2b') : t('operate.ywoekr'))
      toggle()
    } catch (error) {
      loading.value = false
    }
  })
}
defineExpose({
  toggle
})
</script>

<style lang="scss" scoped>
.title-box {
  display: flex;
  align-items: center;
  .title-span {
    font-weight: 500;
    color: red;
    font-size: 14px;
  }
}
</style>
